import { useCallback } from 'react';
import { 
  slideInFromLeft,
  slideInFromRight,
  slideOutToLeft,
  slideOutToRight,
  slideCenter,
  slideHidden,
} from '../Carousel.css';
import type { AnimationDirection } from '../utils/carouselUtils';

interface UseCarouselAnimationProps {
  isAnimating: boolean;
  currentChunkIndex: number;
  animatingToIndex: number | null;
  animationDirection: AnimationDirection;
}

export const useCarouselAnimation = ({
  isAnimating,
  currentChunkIndex,
  animatingToIndex,
  animationDirection,
}: UseCarouselAnimationProps) => {
  const getChunkClass = useCallback(
    (chunkIndex: number): string => {
      if (isAnimating) {
        if (chunkIndex === currentChunkIndex) {
          // Current chunk sliding out
          return animationDirection === 'left'
            ? slideOutToLeft
            : slideOutToRight;
        } else if (chunkIndex === animatingToIndex) {
          // New chunk sliding in
          return animationDirection === 'left'
            ? slideInFromRight
            : slideInFromLeft;
        }
      } else if (chunkIndex === currentChunkIndex) {
        // Current chunk at center
        return slideCenter;
      }
      // All other chunks are positioned off-screen but remain in DOM
      return slideHidden;
    },
    [isAnimating, currentChunkIndex, animatingToIndex, animationDirection],
  );

  return {
    getChunkClass,
  };
};
